






















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import moment from "moment";

@Component
export default class TimePickerComponent extends Vue {
  @Prop() value?: Date | null;
  current?: string | null = null;
  isMenuOpen: boolean = false;

  created() {
    if (this.value) this.current = this.value.toISOString().substr(11);
  }

  @Watch("current")
  onChange() {
    this.$emit("input", new Date(this.current || ""));
  }

  get formatedDate(): string {
    return this.current || "";
    // return this.current
    //   ? moment(this.current).format(process.env.VUE_APP_CONFIGS_DATE_FORMAT)
    //   : "";
  }
}
